import { Params } from '@angular/router';
import { FetchArgs } from 'src/app/shared/models/core';
import { interpolateParams } from 'src/app/shared/utilities/interpolate-params';
import { mapFields } from 'src/app/shared/utilities/map-fields';
import { appendQuery, arrayToQuery } from 'src/app/shared/utilities/route';

export function generateQuery(args: FetchArgs) {
    const searchParams = mapFields(args, { pageSize: 'take' });
    const filter = {};
    for (const [key, value] of Object.entries(searchParams.filter)) {
        filter[key] = value;
    }
    return interpolateParams({
        skip: searchParams.skip,
        pageSize: searchParams.take,
        sortField: searchParams.sort.field,
        sortType: searchParams.sort.dir,
        ...filter
    });
}

export function generateQueryString(args: FetchArgs, sortDirectionPropertyName: string = 'sort.type') {
    let queryString = '';
    if (args.filter) {
        for (const filterName in args.filter) {
            const val = args.filter[filterName];

            if (Array.isArray(val)) {
                queryString = appendQuery(queryString, arrayToQuery(`filter.${filterName}`, val));
            } else if (val) {
                queryString = appendQuery(queryString, `filter.${filterName}=${encodeURIComponent(val)}`);
            }
        }
    }

    if (args.sort && args.sort.field && args.sort.field.length) {
        queryString = appendQuery(
            queryString,
            `sort.field=${args.sort.field}&${sortDirectionPropertyName}=${args.sort.dir === 'asc' ? 'asc' : 'desc'}`
        );
    }
    return appendQuery(queryString, `skip=${args.skip}&pageSize=${args.pageSize}`);
}

export function fixDateFilters(args: FetchArgs) {
    if (!args || !args.filter) {
        return;
    }

    for (const field in args.filter) {
        if (Object.prototype.toString.call(args.filter[field]) === '[object Date]') {
            args.filter[field] = args.filter[field].toLocaleString('sv');
        }
    }
}

export function extractFetchArgs(params: Params): FetchArgs {
    const args: FetchArgs = {
        filter: {},
        skip: 0,
        pageSize: 25,
        sort: { field: 'id', dir: 'desc' }
    };
    if (!params) {
        return args;
    }

    if (params.pageSize) {
        args.pageSize = parseInt(params.pageSize, 10);
    }
    if (params.skip) {
        args.skip = parseInt(params.skip, 10);
    }

    for (const filterName in params) {
        if (filterName.startsWith('filter.')) {
            const val = params[filterName];
            args.filter[filterName.substring(7)] = val;
        }
    }

    for (const sortProperty in params) {
        if (sortProperty.startsWith('sort.')) {
            const val = params[sortProperty];
            args.sort[sortProperty.substring(5)] = val;
        }
    }

    return args;
}
